import { render } from "./TrainingTime.vue?vue&type=template&id=04596520&scoped=true"
import script from "./TrainingTime.vue?vue&type=script&lang=js"
export * from "./TrainingTime.vue?vue&type=script&lang=js"

import "./TrainingTime.vue?vue&type=style&index=0&id=04596520&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04596520"]])

export default __exports__